









import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "contract-cancellation-requests-table": () =>
      import(
        "@/components/app/global/contracts/contractCancellationRequestsTable.vue"
      )
  }
})
export default class AdminContractCancellationRequests extends Vue {}
